module.exports = __webpack_public_path__ + "03_long_gold.250253fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_long_gold.png
// module id = xSiY
// module chunks = 0